module.exports = __webpack_public_path__ + "static/OneDot-Light.b6c048dc.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/OneDot-Light.woff
// module id = 733
// module chunks = 114276838955818